<template>
    <v-layout row wrap class="pad-lot-list" v-scroll="onScroll">
        <v-flex xs12 ref="lots">
            <v-data-table
                :headers="headers"
                :items="lots"
                hide-actions
                item-key="id"
                :loading="loading"
                v-model="selected"
                class="pad-lot-table"
                :class="{ 'pad-lot-table-fixed': tableLoaded }">
                <template #items="props">
                    <pad-lot-list-table
                        ref="lot"
                        :id="`lot-item-${props.item.id}`"
                        :item="props.item"
                        :props="props"
                        @expanded="expand"
                        @selected="select"
                        @bidded="selectNext"
                        @done="focusNext" />
                </template>
                <template #expand="props">
                    <pad-lot-list-expand
                        :item="props.item" />
                </template>
            </v-data-table>
        </v-flex>
        <v-flex xs12 v-if="!lots.length && !loading">
            <p>Aucun lot trouvé</p>
        </v-flex>
        <v-flex xs12 v-show="loading">
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate />
        </v-flex>
    </v-layout>
</template>

<script>
import PadLotListTable from '@/components/PadLotListTable'
import PadLotListExpand from '@/components/PadLotListExpand'

export default {
    name: 'pad-lot-list',
    components: { PadLotListTable, PadLotListExpand },
    data: () => ({
        start: 0,
        limit: 12,
        ended: false,
        loading: false,
        tableLoaded: false,
        lastVacation: null,
        lastProps: null,
        selected: [],
        current: null,
        headers: [
            { text: 'N°', value: 'nb', sortable: false, align: 'right' },
            { text: 'Description', value: 'title', sortable: false },
            { text: 'Estim.', value: 'estimates', sortable: false },
            { text: 'Vendeur', value: 'owner', sortable: false },
            { text: 'Rés.', value: 'reserve_price', sortable: false, align: 'right' },
            { text: 'Ordres fixes', value: 'bids', sortable: false, align: 'right' },
            { text: 'Ordres tél', value: 'telbids', sortable: false, align: 'right' },
            { text: 'Adjudic. CHF', value: 'sell_price', sortable: false },
            { text: 'Acheteur', value: 'buyer_id', sortable: false }
        ]
    }),
    computed: {
        lots() {
            return this.$store.getters['lot/list']
        },
        vacation() {
            return this.$store.getters['sale/vacation']
        },
        vacationId() {
            return this.vacation.id
        },
        saleId() {
            return this.$store.getters['sale/sale'].id
        },
        switchCurrent() {
            return this.$store.getters['lot/switchCurrent']
        },
        notes() {
            return this.$store.getters['lot/notes']
        },
        messagePopupShow() {
            return this.$store.getters['msg/show']
        }
    },
    watch: {
        vacationId: 'load',
        saleId: 'clear',
        switchCurrent: 'goCurrent',
        notes: 'lotsNotes',
        messagePopupShow(v) {
            !v && this.selected.length && this.focusNext()
        }
    },
    mounted() {
        this.load()
    },
    methods: {

        setTableHeadersFixed() {
            if (!this.lots.length) {
                this.tableLoaded = false
                return
            }
            const thr = this.$refs.lots.querySelector('thead tr')
            const ths = thr.querySelectorAll('th')
            const tdr = this.$refs.lots.querySelector('tbody tr')
            const tds = tdr.querySelectorAll('td')
            ths.forEach((th, i) => {
                th.style.width = `${tds.item(i).offsetWidth}px`
            })

            const tbody = this.$refs.lots.querySelector('tbody')
            tbody.style.borderTop = `${thr.offsetHeight * 1.1}px solid white`

            this.tableLoaded = true
        },

        load() {
            if (!this.vacation.id) {
                return this.$store.commit('lot/list', { lots: [] })
            }
            if (this.lastVacation !== this.vacation.id) {
                this.$store.commit('lot/list', { lots: [] })
                this.start = 0
            }
            this.lastVacation = this.vacation.id
            this.loading = true
            return this.$api.get(`/apad/vacations/${this.vacation.id}/lots?start=${this.start}&limit=${this.limit}`)
                .then((res) => {
                    this.ended = res.data.length === 0
                    this.$store.commit('lot/addList', { lots: res.data })
                    return new Promise(resolve => {
                        this.$nextTick(() => {
                            if (this.current) {
                                this.ensureVisible({ ...this.current }).then(resolve)
                                this.current = null
                                return
                            }
                            this.setTableHeadersFixed()
                            resolve()
                        })
                    })
                })
                .finally(() => this.loading = false)
        },

        clear() {
            this.$store.commit('lot/list', { lots: [] })
        },

        onScroll(e) {
            if (this.notes) {
                return
            }
            const el = e.target.scrollingElement
            const pivot = el.offsetHeight - (el.clientHeight * 1.4)
            const test = el.scrollTop

            if (!this.loading && !this.ended && test >= pivot) {
                this.start += this.limit
                this.load()
            }
        },

        expand(data) {
            data.props.expanded = !data.props.expanded
            if (data.props.expanded) {
                this.$router.replace({ name: 'lots', query: { tab: data.tab } })
                this.centerTo(50)
            }
        },

        select(data) {
            let adjustOffset = 0
            if (this.lastProps && this.lastProps.expanded) {
                this.lastProps.expanded = false
                adjustOffset = 400
            }
            data.props.selected = !data.props.selected
            this.selected = [data.item]
            this.lastProps = data.props
            this.centerTo(adjustOffset)
            this.$nextTick(() => this.setTableHeadersFixed())
        },

        selectNext(data) {
            const index = this.lots.findIndex(lot => lot.id === data.item.id)
            if (index > -1 && this.lots.length >= index + 1) {
                this.selected = [this.lots[index + 1]]
                this.centerTo(data.expanded && 400)
            }
        },

        focusNext() {
            if (!this.selected.length) {
                return
            }
            const item = this.selected[0]
            this.$set(item, 'focus', !item.focus)
        },

        centerTo(offset) {
            this.$nextTick(() => {
                const item = this.selected[0]
                if (!item) {
                    return
                }
                const el = document.querySelector(`[data-id="${item.id}"]`)
                this.$vuetify.goTo(el, {
                    offset: offset || 180
                })
            })
        },

        goCurrent() {
            if (this.loading) {
                return
            }
            this.loading = true
            this.$api.get(`/apad/sales/${this.saleId}/current`)
                .then(res => {
                    if (!res.data) {
                        return
                    }
                    if (res.data.vacation !== this.vacationId) {
                        this.current = res.data
                        this.$store.dispatch('sale/selectVacation', { vacation: res.data.vacation })
                        return
                    }
                    return this.ensureVisible(res.data)
                })
                .finally(() => {
                    if (!this.current) {
                        // le load va continuer avec le chargement de la
                        // nouvelle vacation
                        this.loading = false
                    }
                })
        },

        lotsNotes() {
            if (!this.notes) {
                this.$store.commit('lot/list', { lots: [] })
                return this.load()
            }
            this.loading = true
            return this.$api.get(`/apad/sales/${this.saleId}/notes`)
                .then((res) => {
                    this.start = 0
                    this.ended = false
                    this.$store.commit('lot/list', { lots: res.data })
                    return new Promise(resolve => {
                        this.$nextTick(() => {
                            this.setTableHeadersFixed()
                            resolve()
                        })
                    })
                })
                .finally(() => this.loading = false)
        },

        ensureVisible(lot) {
            const current = this.lots.find(l => l.id === lot.id)
            if (current) {
                const el = document.querySelector(`[data-id="${current.id}"]`)
                this.selected = [current]
                this.$nextTick(() => {
                    this.$vuetify.goTo(el, {
                        offset: 200
                    })
                })
                return Promise.resolve()
            }
            // on va récupérer tous les lots de la vacation jusqu'au lot actuel
            const data = {
                vacation: this.vacation.id,
                start: this.start,
                lot: lot.id
            }
            return this.$store.dispatch('lot/currentList', data)
                .then(() => {
                    return new Promise(resolve => {
                        window.setTimeout(() => {
                            this.ensureVisible(lot)
                            resolve()
                        }, 700)
                    })
                })
        }
    }
}
</script>

<style lang="stylus">
.pad-lot-list
    text-align: center;

    .pad-lot-table-fixed > div > table > thead
        background-color: white;
        position: fixed;
        z-index: 1;

    .v-datatable__expand-row
        text-align: left;

</style>
